import { ReactComponent as FacebookIcon } from "../../assets/images/facebook.svg";
import { ReactComponent as InstagramIcon } from "../../assets/images/instagram.svg";
import { ReactComponent as TwitterIcon } from "../../assets/images/twitter.svg";
import { ReactComponent as YoutubeIcon } from "../../assets/images/youtube.svg";
import { FooterContainer, FooterWrapper, IconWrapper } from "./style";

const Footer = (props) => {
  return (
    <FooterWrapper>
      <FooterContainer>
        <IconWrapper>
          <a href={'https://www.facebook.com/No-Fixed-Addresses-110322424488304'} target="_blank" rel="noreferrer noopener" >
            <FacebookIcon />
          </a>
          <a href={'https://www.instagram.com/no_fixed_addresses/'} target="_blank" rel="noreferrer noopener" >
            <InstagramIcon />
          </a>
          <a href={'https://twitter.com/no_fxd_adrs'} target="_blank" rel="noreferrer noopener">
            <TwitterIcon />
          </a>
          <a href={'https://www.youtube.com/channel/UCMMms_ANQLdTrGp534PlqEQ'} target="_blank" rel="noreferrer noopener" >
            <YoutubeIcon />
          </a>
        </IconWrapper>
      </FooterContainer >
    </FooterWrapper >
  );
};

export default Footer;
